import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { SERVICE_URL } from '../../../../tokens';

@Injectable({
  providedIn: 'root',
})
export class BrowseFormService {

    // replace with variable key
    private defaultTPAClientIdentifier = environment.defaultTPAClientIdentifier

    private data: Observable<any>;

    constructor(private http: HttpClient, @Inject(SERVICE_URL) private serviceUrl: any) {
        this.serviceUrl = `${serviceUrl}CareTypes`;
    }

    getCareTypes(): Observable<any> {

        const params = new HttpParams({
            fromObject: {
                'tpaClientIdentifier' : this.defaultTPAClientIdentifier,
            }
        });

        return this.http.get(this.serviceUrl, {params: params});
    }
}
